import { useState } from "react";
import { toast } from "react-toastify";
import UseContext from "hooks/useContext";
import useModal from "components/modal/useModal";
import {
    getPerimeterErrorMessage,
    isNameError,
    isStalePerimeterError,
} from "pages/profil/perimeters/perimeterErrors";

// Behaviour shared by the perimeter modals: a close that waits for the request
// in flight, a list reload after a write, and one policy for the api errors.
const usePerimeterModal = () => {
    const { toggle } = useModal();
    const { language, setPerimeterModalData, setRefreshPerimeters } =
        UseContext();
    const [isSaving, setIsSaving] = useState(false);

    // Closing while the request is in flight would hide its outcome.
    const close = () => {
        if (isSaving) return;
        setPerimeterModalData(null);
        toggle();
    };

    const closeAndReload = () => {
        setPerimeterModalData(null);
        setRefreshPerimeters((count) => count + 1);
        toggle();
    };

    const succeed = (message) => {
        toast.success(message);
        closeAndReload();
    };

    // A perimeter that changed or vanished closes the modal and reloads the
    // list. Otherwise a name error goes under the field when the modal has
    // one, and anything else is a toast on the open modal.
    const fail = (err, { overrides, onNameError } = {}) => {
        console.error(err);
        const message = getPerimeterErrorMessage(language, err, overrides);
        if (isStalePerimeterError(err)) {
            toast.error(message);
            closeAndReload();
            return;
        }
        setIsSaving(false);
        if (onNameError && isNameError(err)) onNameError(message);
        else toast.error(message);
    };

    return { isSaving, setIsSaving, close, succeed, fail };
};

export default usePerimeterModal;
